import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getSingleDrone, getDronesParts } from "../../services/DroneServices";
import HTMLReactParser from "html-react-parser";
import DroneInquire from "../common/DroneEnquiry";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { handleChangeCartCount, handleLoginPopup } from "../../redux/slice/userSlice";
import arrowback from "../../assets/image/png/arrow_back.png";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ReactImageMagnify from "react-image-magnify";
import madeinindia from "../../assets/image/png/Madeinindia2.png"
import typeCertified from "../../assets/image/png/type-certified.png"
import SlidingNotice from "../common/SlidingNotice";

 
const ProductDetailHero = () => {
  const token = Cookies.get("token");
  const [selectedImage, setSelectedImage] = useState(null);
  const [model, setModel] = useState(false);
  const [specifications, setSpecifications] = useState([]);
  const [allDroneParts, setAllDroneParts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [quantity, setQuantity] = useState(1); // Initialize quantity with default value
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [droneDetails, setDroneDetails] = useState("");
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const handleLoadMore = () => {
    setPage(page + 1); // Optional: update page number in state
    navigate(`/drone-parts?page=${page + 1}`); // Navigate with query param
  };
  useEffect(() => {
    if (id) {
      
      getSingleDrone(id).then((res) => {
        if (res.status === "success") {
          setDroneDetails(res.data);
          setSelectedImage(res.data.images[0]);
          setQuantity(res.data.quantity || 1); // Ensure quantity is set properly
          if (res.data?.specsOfDrone) {
            setSpecifications(JSON.parse(res.data.specsOfDrone));
          }
        } else {
          console.error("Failed to fetch single drone details");
        }
      });
    }
  }, [id]);
 
  useEffect(() => {
    fetchDroneParts();
  }, [page]);
 
  const fetchDroneParts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getDronesParts({ limit: 8, page, search: "" });
      if (response.status === "success") {
        setAllDroneParts((prevAllDroneParts) => [
          ...prevAllDroneParts,
          ...response.data.droneParts,
        ]);
        if (response.data.totalPages !== 0) {
          setTotalPage(response.data.totalPages);
        }
      } else {
        setError("Failed to fetch drone parts");
        console.error("Error: Failed to fetch drone parts");
      }
    } catch (error) {
      setError("An error occurred while fetching drone parts");
      console.error("Error during fetchDroneParts:", error);
    } finally {
      setLoading(false);
    }
  };
 
  const handleCart = async () => {
  if (!token) {
    dispatch(handleLoginPopup(true));
    return;
  }

  try {
    // If this drone has a redirect URL (for Mithron)
    if (droneDetails?.redirectUrl) {
      // 1️⃣ Log the lead before redirecting
      await axios.post(
        process.env.REACT_APP_API_URL + "/generateMithronLead",
        {
          droneId: id,
          redirectUrl: droneDetails.redirectUrl,
        },
        {
          headers: { token: Cookies.get("token") },
        }
      );

      // 2️⃣ Redirect to Mithron’s portal
      // ✅ Show toast before redirect
      toast.info("Redirecting you to Mithron's Portal...", { autoClose: 1500 });

      // Delay redirect slightly so user sees the toast
      setTimeout(() => {
        window.open(droneDetails.redirectUrl, "_blank");
      }, 1500);
      return; // stop normal cart flow
    }

    // 🔹 Normal cart flow for other drones
    const payload = { droneId: id, quantity, droneIdd: id };

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/addToCart",
      payload,
      {
        headers: { token: Cookies.get("token") },
      }
    );

    if (response?.data?.status === "success") {
      // Update state to show this drone in the cart with item details
      setDroneDetails({ ...droneDetails, isCartItem: true, quantity });

      // Dispatch to update cart count and notify user
      dispatch(handleChangeCartCount(1));
      toast.success(response?.data?.message || "Drone added to cart successfully");
    } else {
      toast.error(response?.data?.message || "Failed to add drone to cart");
      console.error("Failed to add drone to cart:", response?.data?.message);
    }
  } catch (error) {
    toast.error("An error occurred while adding the drone to the cart");
    console.error("Add to Cart Error:", error);
  }
};

 
 
  const handleUpdateQuantity = async (id, quantity) => {
 
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/updateDronePartQuantity`,
        { droneId: id, quantity },
        {
          headers: {
            token: Cookies.get("token"),
          },
        }
      );
 
      if (response?.data?.status === "success") {
        toast.success("Quantity Updated Successfully");
        setDroneDetails({ ...droneDetails, quantity: quantity });
      } else {
        console.error("Failed to update quantity:", response?.data?.message);
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  };
 
  const handleThumbnailClick = (thumbnail) => {
    setSelectedImage(thumbnail);
  };
 
 
  return (

    <>
    {/* <SlidingNotice /> */}
    <div className="pb-5 bg-white">
      <div className="py-4 bg-white mt-3">
        <div className="container">
          {/* {droneDetails?.madeInIndia && (
            <div
              className="position-absolute top-0 end-0 me-4 mt-4 bg-success text-white px-3 py-2 rounded-start shadow"
              style={{ zIndex: 10 }}
            >
              <strong>🇮🇳 Made in India</strong>
            </div>
          )} */}

          <p className="mb-0 color_darkgray fw-normal ff_inter fs_21">
            <span className=" color_blue">
              <Link to="/product/all-drone"> All Drone</Link>
            </span>
            / {droneDetails?.categoryId?.name} / {droneDetails?.name}
          </p>
        </div>
      </div>
      <div
        className="d-flex align-items-center gap-1 cursor_pointer ms-4"  // Added ms-2 for left margin
        onClick={() => navigate("/product/all-drone")}
      >
        {/* <img
          style={{ width: "18px", height: "18px" }}  // Fixed typo in height
          src={arrowback}
          alt="backarrow"
        />
        <p className="mb-0 color_blue_2 fw-medium">Back to page</p> */}
      </div>
            <div className="pt-1 bg-white">
              <div className="container">
                <div className="row mt-xl-5 mt-4">
                  {/* Thumbnails for Web View */}
                  <div className="col-1 d-xl-block d-none">
                    {droneDetails?.images?.map((item, index) => (
                      <img
                        key={index}
                        height={72}
                        className="w-100 rounded-2 mb-2 object-fit-contain cursor_pointer"
                        src={item}
                        alt="product_demoimage"
                        onClick={() => handleThumbnailClick(item)}
                      />
                    ))}
                    
                  </div>

                  {/* Main Image for Web and Carousel for Mobile */}
                  <div className="col-xl-5 col-lg-6" style={{ maxWidth: "500px" }}>
                    {/* Web View */}
                    <div className="d-none d-xl-block" style={{ position: "relative" }}>
                      {droneDetails?.madeInIndia && (
                        <img
                          src={madeinindia}
                          alt="Made in India"
                          style={{
                            position: "absolute",
                            // top: "10px",
                            left: "10px",
                            height: "50px",
                            zIndex: 2,
                          }}
                        />
                      )}

                      {/* Type Certified Logo (right side) */}
                        {droneDetails?.typeCertified && (
                          <img
                            src={typeCertified}
                            alt="Type Certified"
                            style={{
                              position: "absolute",
                              right: "10px",
                              // top: "10px",
                              height: "25px",
                              zIndex: 2,
                            }}
                          />
                        )}
                      <ReactImageMagnify
                        {...{
                          smallImage: {
                            alt: "product_detail_image",
                            isFluidWidth: true,
                            src: selectedImage,
                          },
                          largeImage: {
                            src: selectedImage,
                            width: 900,
                            height: 900,
                          },
                          enlargedImagePosition: "over",
                          shouldUsePositiveSpaceLens: true,
                        }}
                      />
                    </div>


              {/* Mobile View */}
              <div className="d-block d-xl-none" style={{ position: "relative" }}>
                {droneDetails?.madeInIndia && (
                  <img
                    src={madeinindia}
                    alt="Made in India"
                    style={{
                      position: "absolute",
                      // top: "10px",
                      // left: "10px",
                      height: "50px",
                      zIndex: 2,
                    }}
                  />
                )}

                {/* Type Certified Logo (right side) */}
                {droneDetails?.typeCertified && (
                  <img
                    src={typeCertified}
                    alt="Type Certified"
                    style={{
                      position: "absolute",
                      right: "10px",
                      // top: "10px",
                      height: "25px",
                      zIndex: 2,
                    }}
                  />
                )}

                {droneDetails?.images?.length > 1 ? (
                  <Slider {...settings}>
                    {droneDetails?.images?.map((item, index) => (
                      <div key={index}>
                        <img
                          className="w-100 object-fit-contain rounded-3"
                          src={item}
                          alt="product_detail_image"
                        />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <img
                    className="w-100 object-fit-contain rounded-3"
                    src={selectedImage}
                    alt="product_detail_image"
                  />
                )}
              </div>

              
            </div>
            

            {/* Product Details */}
            <div className="col-lg-6 mt-5 mt-lg-0 d-flex flex-column">
              {/* Product Name */}
              <h3 className="fs_43 fw-bold mt-3 ff_inter color_darkgray">
                {droneDetails?.name}
              </h3>

              {/* Product Description (Inside a Box) */}
              <div
                className="description-box mt-3"
                style={{
                  // padding: "5px 15px 15px 0px",
                  background: "#f9f9f9", // Light grey background
                  borderRadius: "8px",
                  maxWidth: "100%", // Ensures it fits inside the column
                  textAlign: "justify",
                  lineHeight: "1.5", // Improved readability
                }}
              >
                <p className="fs_17 ff_inter color_darkgray mb-0">
                  {droneDetails?.description}
                </p>
              </div>

              {/* Price */}
              <div className="mt-3">
                <span className="fs_20 fw-semibold ff_inter color_darkgray">
                  Rs. {new Intl.NumberFormat("en-IN").format(droneDetails?.approvedPrice)}
                </span>
              </div>

              {/* Quantity & Buttons */}
              <div className="d-flex gap-3 mt-4 align-items-center">
              
                <div className="d-flex align-items-center border rounded px-3 py-0">
                  <button
                    onClick={() => quantity > 1 && setQuantity(quantity - 1)}
                    className="fs_26 ff_inter bg-transparent border-0"
                  >
                    -
                  </button>
                  <span className="mx-3 fs_18 ff_inter">{quantity}</span>
                  <button
                    onClick={() => quantity < 10 && setQuantity(quantity + 1)}
                    className="fs_26 ff_inter bg-transparent border-0"
                  >
                    +
                  </button>
                </div>

               
                {droneDetails?.isCartItem && droneDetails.quantity === quantity ? (
                  <button
                    className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
                    onClick={() => navigate("/cart")}
                  >
                    View Cart
                  </button>
                ) : token && droneDetails?.isCartItem ? (
                  <button
                    className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
                    onClick={() => handleUpdateQuantity(droneDetails._id, quantity)}
                  >
                    Add to Cart
                  </button>
                ) : (
                  <button
                    className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
                    onClick={() => handleCart()}
                  >
                    Add to Cart
                  </button>
                )}
              </div>

              {/* Button */}
              {/* Enquire Now Button */}
              {/* <button
                  className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white mt-4"
                  onClick={() => setModel(true)}
                >
                  Enquire Now
                </button>
                <DroneInquire setModel={setModel} model={model} /> */}
              </div>


          </div>
        </div>
      </div>

 
      <div className="">
  <div className="container">
    <div className="bg_lightblue mt-5 p-md-5 p-4 rounded-5 shadow-sm">
      <h4 className="fs_26 fw-bold ff_inter color_blue mb-0 text-center">
         Specifications
      </h4>

      <div className="mt-5">
        <div className="row g-4">
          {specifications.map((item, index) => (
            <div key={index} className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex align-items-start bg-white rounded-4 shadow-sm border border-light px-4 py-3 h-100 hover-shadow transition">
                <div className="me-3">
                  <div className="bg_blue text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                    ⚙️
                  </div>
                </div>
                <div>
                  <h6 className="mb-1 fw-semibold text-dark">{item.title}</h6>
                  <p className="mb-0 small text-secondary fw-medium">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Optional: Quote Section */}
      {/* <div className="d-sm-flex align-items-center mt-5 justify-content-between">
        <div>
          <h3 className="ff_inter fs_26 fw-bold color_blue mb-0">
            REQUEST A QUOTE
          </h3>
          <p className="fs_21 fw-normal mb-4 mb-sm-0 ff_inter color_darkgray mt-1">
            Request a Quote for {droneDetails?.name}
          </p>
        </div>
        <button
          onClick={() => setModel(true)}
          className="text-nowrap viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
        >
          Request a Quote
        </button>
      </div> */}
    </div>
  </div>
</div>

      <div className="container py-5">
        {allDroneParts.length !== 0 && (
          <h4 className="ff_inter fs_43 fw-semibold">Explore Drone Parts</h4>
        )}
        <div className="row pb-md-4">
  {allDroneParts
    .filter((item) => !item?.title?.toLowerCase().includes("plan")) // exclude "plan"
    .map((item, index) => (
      <div
        key={index}
        className="col-lg-3 cursor_pointer col-sm-6 col-md-4 mt-4 col-12"
      >
        <Link to={`/drone-part-details/${item._id}`}>
          <div className="border d-flex flex-column justify-content-between border-1 h-100 rounded-3">
            <div>
              <img
                height={200}
                className="mx-auto w-100 object-fit-contain w_xsm_full rounded-3"
                src={item.images[0]}
                alt="drone image"
              />
              <p className="px-3 mt-3 fs_15 fw-bold ff_inter color_darkgray mb-0 mt-3">
                {item?.title.split("").slice(0, 50).join("")}...
              </p>
            </div>
            <div className="mt-3 px-3">
              <div className="mt-3 d-flex justify-content-between mb-3 align-items-center">
                <div className="d-flex flex-column">
                  <span className="fs_15 fw-bold ff_inter color_darkgray mb-0">
                    {/* Rs. {item.discountPrice} */}
                    {/* Rs. {new Intl.NumberFormat('en-IN').format(item.discountPrice)} */}
                  </span>
                  <span className=" fs_15 ff_inter">
                    Rs. {new Intl.NumberFormat("en-IN").format(item.approvedPrice)}
                  </span>
                </div>
                <div>
                  <button className="viewall_btn bg_light_blue px-4 py-2 fs_17 fw-medium ff_inter text-white text-nowrap">
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    ))}

  {loading && (
    <div className="d-flex justify-content-center">
      <p>Loading...</p>
    </div>
  )}

  {error && (
    <div className="d-flex justify-content-center">
      <p className="text-danger">{error}</p>
    </div>
  )}

  {page !== totalPage && (
    <div className="d-flex justify-content-center">
      <button
        onClick={handleLoadMore}
        className="tab_btn px-4 py-2 border-0 rounded-2 mt-5 fs_13 ff_inter fw-semibold text-white"
      >
        Load More
      </button>
    </div>
  )}
</div>

      </div>
      <DroneInquire setModel={setModel} model={model} />
      {/* <ToastContainer /> */}
    </div>
    </>
  );
};
 
export default ProductDetailHero;